import React, { Component } from 'react';
import cn from 'classnames';
import styles from './Type.scss';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';

const variants = {
  flat: { param: 'flat', key: 'apartmentRoom', text: i18n.t('components.header.filtersBar.filters.type.flat'), event: 'Web_Filters_Flat' },
  apt: { param: 'apt', key: 'apartRoom', text: i18n.t('components.header.filtersBar.filters.type.apt'), event: 'Web_Filters_Apartments' },
  lvn: { param: 'lvn', key: 'zhiloeRoom', text: i18n.t('components.header.filtersBar.filters.type.lvn') },
  nlvn: { param: 'nlvn', key: 'nezhiloeRoom', text: i18n.t('components.header.filtersBar.filters.type.nlvn') }
};

export const parseSearch = (search) => {
  const { type } = search;
  if (!type) {
    return { type: [] };
  }
  const keys = type.split(',');
  return {
    type: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.param)) {
          prev.push(variant.key);
        }
        return prev;
      }, [])
  };
};

export const compileSearch = (data) => {
  const { type: keys } = data;
  if (!keys || !keys.length) {
    return { type: undefined };
  }

  return {
    type: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.param);
        }
        return prev;
      }, [])
      .join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { type } = data;
  return { typeRoom: type.length ? type : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { type: keys } = parseSearch(search);
  return Object.keys(variants)
    .reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.key)) {
        prev.push(variant.text);
      }
      return prev;
    }, [])
    .join(', ') || i18n.t('components.header.filtersBar.filters.type.notSelected');
};

class Type extends Component {
  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { dropdownData } = this.props;
    const data = { type: [] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick('type');
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData } = this.props;
    const { type: keys } = parseSearch(search);
    const type = [...keys];

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    if (type.includes(key) !== add) {
      if (add) {
        type.push(key);
      } else {
        type.splice(type.indexOf(key), 1);
      }
    }

    const data = { type };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, additional } = this.props;
    const { type } = parseSearch(search);

    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={type.includes(variant.key)}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        additional={additional}
        text={variant.text}
      />
    );
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { type } = parseSearch(search);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.type.title')}
          {!additional ? (
            !!type.length &&
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.type.clear')}
            </Button>
          ) : (null)}
        </p>
        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {this.checkbox('flat')}
          </div>
          <div className={styles.SecondColumn}>
            {this.checkbox('apt')}
          </div>
        </div>
        {additional ? (
          <div className={styles.ButtonWrap}>
            {!!type.length &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.type.clear')}
              </Button>}
          </div>
        ) : (null)}
      </div>
    );
  }
}

export default withTranslation()(Type);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Type/Type.js